import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ContractTeamHeader from '../../../ContractTeamHeader';
import AppointeesTable from './AppointeesTable';
import ModalAlert from '../../../../../ContractManagement/Markers/Components/ViewAlert/ViewAlert';
import Page from 'Common/Layout/Page';

const AppointeesView = props => {
	const { teamId, handleErrors,year, ...headerProps } = props;
	const initNotice = { message: '', errors: [] };
	const [notice, setNotice] = useState(initNotice);
	const { message, errors } = notice;
	const clear = () => setNotice(initNotice);

	return (
		<>
			<Page title="Contract Release Post EX6">
				<ModalAlert message={message} errors={errors} clearMessage={clear} />
				<ContractTeamHeader {...headerProps} qualYear={parseInt(year)} />
				<AppointeesTable {...props} setNotice={setNotice} />
			</Page>
		</>
	);
};

AppointeesView.propTypes = {
	apptType: PropTypes.string.isRequired,
	teamTitle: PropTypes.string.isRequired,
	teamCode: PropTypes.string.isRequired,
	teamId: PropTypes.number.isRequired,
	year: PropTypes.number.isRequired,
	handleErrors: PropTypes.func.isRequired,
	setTeam: PropTypes.func.isRequired,
	initialTeam: PropTypes.object.isRequired
};

export default AppointeesView;
